// socketService.ts
import { io } from "socket.io-client";

let socket = null;

export const initializeSocket = () => {
  if (socket?.connected) return socket;
  if (socket && socket.connected) return socket;
  if (socket && !socket.connected) socket.connect();

  socket = io(process.env.REACT_APP_BACKEND_URL, {
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    timeout: 30000,
  });

  socket.on('connect', () => {
    console.log('✅ Connected:', socket?.id);
  });

  socket.on('disconnect', reason => {
    console.log('⚠️ Disconnected:', reason);
  });

  socket.on('error', err => {
    console.log('❌ Connection error:', err.message);
  });

  return socket;
};

export const getSocket = () => socket;
export const closeSocket = () => {
  if (socket) socket.disconnect();
  socket = null;
};